export default function BulkDeleteControlsConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  controlDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete($event) {
    loaderService.showViewLoader = true;
    const idList = {};
    idList.ids = vm.controls;
    return controlDataService.bulkDeleteControls(idList).then((result) => {
      if (result.status === 200) {
        alerts.success('All controls were successfully deleted.');
        if (vm.updateCallBack) {
          vm.updateCallBack();
        }
        _closeDialog($event);
      } else {
        alerts.error('An error occurred while deleting all controls.');
      }
    }).catch(() => {
      alerts.error('An error occurred while deleting all controls.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.controlAdmin.bulkDeleteControlsConfirmDialog);
  }
}

BulkDeleteControlsConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'controlDataService',
  'loaderService',
  'ssDialogService'
];
